/// <summary>
/// 游戏界面生命周期监听
/// </summary>
/// <author>xiexingwu</author>

export interface IGameLifecycle {
    onGameCreated(): void;

    onGameResumed(): void;

    onGamePaused(): void;
}


/// <summary>
/// 游戏界面生命周期
/// </summary>
/// <author>xiexingwu</author>
export class GameLifecycle {
    static lifecycle: IGameLifecycle | null = null

    static set(lifecycle: IGameLifecycle | null): void {
        this.lifecycle = lifecycle;
    }

    static GameCreated = (): void => {
        this.lifecycle?.onGameCreated();
    };

    static GameResumed = (): void => {
        this.lifecycle?.onGameResumed();
    };


    static GamePaused = (): void => {
        this.lifecycle?.onGamePaused();
    };
}